// @flow strict
import apiRequest from '../../stores/ApiService';

type CostCentres = Array<{ label: string }>;

type AccountSettings = {
  isInvoicingEnabled: Boolean,
  isPaymentRestrictedToInvoicing: Boolean,
  isPONumberEnabled: Boolean,
  isPONumberRequired: Boolean,
  costCentres: CostCentres,
  isCostCentreRequired: Boolean,
};

type AccountSettingsResponse = { +json: () => Promise<AccountSettings> } & Response;

export const getAccountSettings = (url: string): Promise<AccountSettingsResponse> =>
  apiRequest({
    method: 'GET',
    url,
  });

export const updateAccountSettings = (url: string, body: AccountSettings) =>
  apiRequest({
    method: 'PATCH',
    url,
    body: JSON.stringify(body),
  });
